import { defineMessages } from 'react-intl';

export default defineMessages({
  setAccessGroupButtonLabel: {
    defaultMessage: 'Set access groups',
    description: 'Set Access groups button - label',
    id: 'setAccessGroupButton.label',
  },
});
